import React from "react";
import StarRatings from "./starRatings";
import RatingsBadge from "./ratingBadge";  
import StoreInfo from "../storeInfo";
import LoadingSpinner from "../../../UI/spinner";
import DeleteIcon from "../../../Common/svg/deleteicon";
import ReviewActions from "../reviewActions";
import Can from "../../../../utils/can";

const ReviewsCard = ({ review,isLoading ,refetch }) => {
  console.log('isLoading', isLoading)
  return (
    <div className={`card rounded-3 review-card   `}>
      <div className="card-body">

   
           <div className="d-flex justify-content-between align-items-center flex-wrap mb-2">
          <h5 className="font14">{review.user.name}</h5>
          <div className="d-flex align-items-center"><span> {review.created_at}</span>  </div>
        </div>
        <div className="d-flex justify-content-between align-items-center  flex-wrap mb-2">
          <StarRatings rating={review?.rating} />
          <div className="d-flex align-items-center flex-wrap gap-2">
            {review.ratings.map((rating, index) => (
              <RatingsBadge key={index} rating={rating} />
            ))}
          </div>
        </div>
        <StoreInfo review={review} />
        <p className="bg-smoke mt-3 p-2 rounded-3">{review.comment}</p>

        <div className="bg-smoke rounded-4 mt-3 p-3  phone" >
          <span>{review.user.phone}</span> : <span >رقم الجوال</span>     
        </div>
       
      </div>
    </div>
  );
};

export default ReviewsCard;
